var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWebcam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.75,68V47A3.75442,3.75442,0,0,0,67,43.25H52.75V40a.7502.7502,0,0,0-.75-.75H46.75v-2.5H64a.7502.7502,0,0,0,.75-.75V24a.7502.7502,0,0,0-.75-.75H16a.7502.7502,0,0,0-.75.75V36a.7502.7502,0,0,0,.75.75H33.25v2.5H28a.7502.7502,0,0,0-.75.75v3.25H12A2.7528,2.7528,0,0,0,9.25,46V68h1.5V46A1.25116,1.25116,0,0,1,12,44.75H27.25V48a.7502.7502,0,0,0,.75.75H52a.7502.7502,0,0,0,.75-.75V44.75H67A2.25278,2.25278,0,0,1,69.25,47V68Zm-24-42A1.25116,1.25116,0,0,1,48,24.75H63.25v10.5H48A1.25116,1.25116,0,0,1,46.75,34Zm-30,9.25V24.75H45.56445A2.71455,2.71455,0,0,0,45.25,26v8a2.71455,2.71455,0,0,0,.31445,1.25H16.75Zm28.5,1.5v2.5H34.75v-2.5Zm6,10.5H28.75v-6.5h22.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40,32.75A2.75,2.75,0,1,0,37.25,30,2.7528,2.7528,0,0,0,40,32.75Zm0-4A1.25,1.25,0,1,1,38.75,30,1.25116,1.25116,0,0,1,40,28.75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 30,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebcam);
export default __webpack_public_path__ + "static/media/icon_webcam.1e8360e39fe6d2ecec15d5b237ceb29a.svg";
export { ForwardRef as ReactComponent };